const validate = values => {
    const errors = {};
    if (!values.emailId) {
        errors.emailId = 'Please enter your email address';
    }
    if (
        values.emailId &&
        !/^[A-Za-z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/.test(values.emailId)
    ) {
        errors.emailId = 'Please enter a valid email address';
    }
    if (!values.password) {
        errors.password = 'Please enter a password';
    }
    if (values.password && values.password.length > 127) {
        errors.password =
            'Invalid password. Length greater than 127 characters.';
    }
    return errors;
};

export default validate;
